var React = require('react');

function CaretCircleUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm123 296H133a12 12 0 0 1-8.5-20.5l123-123a12 12 0 0 1 17 0l123 123A12 12 0 0 1 379 304z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M379 304H133a12 12 0 0 1-8.5-20.5l123-123a12 12 0 0 1 17 0l123 123A12 12 0 0 1 379 304z","className":"fa-primary","key":2})]);
}

CaretCircleUp.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CaretCircleUp;

CaretCircleUp.default = CaretCircleUp;
